import { render, staticRenderFns } from "./WsRequestExamGroupForm.vue?vue&type=template&id=701e25dc"
import script from "./WsRequestExamGroupForm.vue?vue&type=script&lang=js"
export * from "./WsRequestExamGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports